function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { mapState } from 'vuex';
import businessTermService from '@/apps/data-platform/services/master_data/business_term_service';
export var businessGlossaryMixin = {
  data: function data() {
    return {
      kdomain: '',
      ksubdomain: null,
      kbusiness_term: null,
      UNDEFINED: 'Undefined',
      terms: [],
      tree: [],
      bt_add: {
        kdomain: null,
        domain_description: '',
        organization: '',
        ksubdomain: null,
        subdomain_description: '',
        kbusiness_term: null,
        term_description: '',
        term_definition: '',
        in_report: true
      },
      showShared: false
    };
  },
  methods: {
    getBusinessTerms: function getBusinessTerms() {
      var _this = this;
      var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'intercorp.com.pe';
      this.terms = [];
      var data = {
        domain: domain
      };
      return businessTermService.getBusinessTerms(data).then(function (response) {
        _this.terms = response.data.result.map(function (term) {
          var kdomainTerm = _this.UNDEFINED;
          var domainTerm = _this.UNDEFINED;
          var ksubdomainTerm = _this.UNDEFINED;
          var subdomainTerm = _this.UNDEFINED;
          var subdomain = _this.selectSubdomain.find(function (item) {
            return item.value === term.ksubdomain;
          });
          if (subdomain) {
            kdomainTerm = subdomain.domain;
            domainTerm = subdomain.domain_text;
            ksubdomainTerm = subdomain.value;
            subdomainTerm = subdomain.text;
          }
          return _objectSpread(_objectSpread({}, term), {}, {
            kdomain: kdomainTerm,
            domain: domainTerm,
            subdomain: subdomainTerm,
            ksubdomain: ksubdomainTerm,
            bdomain: _this.userDomain
          });
        });
      });
    },
    onChangeBusinessTerm: function onChangeBusinessTerm() {
      var _this2 = this;
      var term = this.selectBusinessTerm.find(function (x) {
        return x.value === _this2.kbusiness_term;
      });
      if (term) {
        if (this.showShared) {
          var termKdomain = term.kdomain || '';
          var termKsubdomain = term.ksubdomain || '';
          var businessDomain = this.selectDomain.find(function (item) {
            return item.kdomain === termKdomain;
          });
          var businessSubdomain = this.selectSubdomain.find(function (item) {
            return item.domain === termKdomain && item.value === termKsubdomain;
          });
          this.bt_add.kdomain = businessDomain ? termKdomain : this.UNDEFINED;
          this.bt_add.domain_description = businessDomain ? businessDomain.text : '';
          this.bt_add.organization = businessDomain ? businessDomain.organization : window.userInfo.domain;
          this.bt_add.ksubdomain = businessSubdomain ? termKsubdomain : this.UNDEFINED;
          this.bt_add.subdomain_description = businessSubdomain ? businessSubdomain.text : '';
        }
        this.bt_add.kbusiness_term = term.value;
        this.bt_add.term_description = term.text;
        this.bt_add.term_definition = term.definition;
      }
    },
    onLimpiarFiltros: function onLimpiarFiltros() {
      this.bt_add = {
        kdomain: null,
        domain_description: '',
        ksubdomain: null,
        subdomain_description: '',
        kbusiness_term: null,
        term_description: '',
        term_definition: '',
        in_report: true
      };
      this.kdomain = null;
      this.ksubdomain = null;
      this.kbusiness_term = null;
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['selectDomain', 'selectSubdomain', 'selectBusinessTerm'])), {}, {
    filterSubdomain: function filterSubdomain() {
      var _this3 = this;
      return this.selectSubdomain.filter(function (Subdomain) {
        return Subdomain.domain === _this3.kdomain;
      });
    },
    filterBusinessTerm: function filterBusinessTerm() {
      var _this4 = this;
      var callback = this.showShared ? function (x) {
        return x.shared && x.shared === true && !_this4.isTermSelected(x.value);
      } : function (x) {
        return x.ksubdomain === _this4.ksubdomain && !_this4.isTermSelected(x.value);
      };
      var selectbBusinessTerm = this.selectBusinessTerm ? this.selectBusinessTerm.filter(callback) : [];
      return selectbBusinessTerm;
    }
  })
};